import React from"react";var Anchorable=function(_ref){var nodeId=_ref.nodeId,children=_ref.children;return React.cloneElement(React.Children.only(children),{id:"viewer-"+nodeId})};export{Anchorable as default};
//# sourceMappingURL=Anchorable.js.map
